/** @format */
import { ChevronLeft, ChevronRight } from "lucide-react"; // ou react-icons
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const promos = [
  {
    id: 1,
    image: "/images/products/7.jpg",
    title: "Soldes d'été -50%",
    subtitle: "Sur toute la collection mode",
    link: "/products?category=costume homme",
    bgColor: "from-orange-500 to-red-500",
  },
  {
    id: 2,
    image: "/images/products/8.jpg",
    title: "Livraison gratuite",
    subtitle: "Pour toute commande +50 000 FCFA",
    link: "/products",
    bgColor: "from-blue-500 to-indigo-600",
  },
  {
    id: 3,
    image: "/images/products/4.jpg",
    title: "Nouveautés Tech",
    subtitle: "Découvrez les derniers gadgets",
    link: "/products?category=Ordinateur Portable",
    bgColor: "from-emerald-500 to-teal-600",
  },
];

const PromoBanner = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % promos.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index) => setCurrent(index);
  const prev = () => setCurrent((c) => (c - 1 + promos.length) % promos.length);
  const next = () => setCurrent((c) => (c + 1) % promos.length);

  return (
    <div className='w-[95%] mx-auto px-4 sm:px-6 lg:px-8'>
      <div className='relative overflow-hidden rounded-2xl h-[180px] sm:h-[220px] lg:h-[280px]'>
        {promos.map((promo, i) => (
          <Link
            key={promo.id}
            to={promo.link}
            className={`absolute inset-0 flex items-center transition-all duration-700 ease-in-out bg-gradient-to-r ${promo.bgColor} ${
              i === current
                ? "opacity-100 translate-x-0"
                : i < current
                  ? "opacity-0 -translate-x-full"
                  : "opacity-0 translate-x-full"
            }`}
          >
            <div className='relative z-10 px-8 sm:px-12 lg:px-16 text-white'>
              <h3 className='text-xl sm:text-3xl lg:text-4xl font-bold mb-2 drop-shadow-lg'>
                {promo.title}
              </h3>
              <p className='text-sm sm:text-base lg:text-lg opacity-90'>
                {promo.subtitle}
              </p>
              <span className='inline-block mt-4 px-5 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-semibold hover:bg-white/30 transition-colors'>
                Voir plus →
              </span>
            </div>
            {promo.image && (
              <img
                src={promo.image}
                alt={promo.title}
                className='absolute right-0 top-0 h-full w-1/2 object-cover opacity-30'
              />
            )}
          </Link>
        ))}

        {/* Flèches */}
        <button
          onClick={prev}
          className='absolute left-3 top-1/2 -translate-y-1/2 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/40 transition'
        >
          <ChevronLeft size={20} />
        </button>
        <button
          onClick={next}
          className='absolute right-3 top-1/2 -translate-y-1/2 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/40 transition'
        >
          <ChevronRight size={20} />
        </button>

        {/* Dots */}
        <div className='absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex gap-2'>
          {promos.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                i === current ? "bg-white w-6" : "bg-white/50 hover:bg-white/70"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
